import Section from "../ui/Section";
import "./HowItWorks.css";

const STEPS = [
  {
    state: "done",
    title: "Bring your syllabus",
    body: "Paste in whatever outlines the course.",
  },
  {
    state: "current",
    title: "Eolass builds it",
    body: "A full course of ordered problems, minimal explanation.",
  },
  {
    state: "locked",
    title: "Solve it",
    body: "The path adapts as you learn.",
  },
] as const;

export default function HowItWorks() {
  return (
    <Section tone="dim" id="how-it-works">
      <h2 className="how-it-works__heading">How it works</h2>
      <div className="path">
        <span className="path__line" aria-hidden="true" />
        <ol className="path__list">
          {STEPS.map((step) => (
            <li className={`path__step path__step--${step.state}`} key={step.title}>
              <span className="path__circle" />
              <div className="path__text">
                <h3 className="path__title">{step.title}</h3>
                <p className="path__body">{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </Section>
  );
}
